import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import DashboardPages from 'components/Pages/Dashboard/DashboardPages';
import CustomDashboardPages from 'components/Pages/Dashboard/CustomDashboardPages';

const Dashboard = ({ pages }) => {

    return (
        <Grid container spacing={1} direction="row" justifyContent="flex-start">
            <CustomDashboardPages />
            <DashboardPages pages={pages} />
        </Grid>
    );
};

Dashboard.propTypes = {
    pages: PropTypes.array.isRequired,
};

export default Dashboard;
